import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/ca5a912e-8389-4517-9bde-26b1f017b2e4";
export const REGISTER_URL = "https://a.ntrk2.com/09482a07-5bf0-4b73-bdbe-1837b2b9fdfe";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://789abc.kzw2a.com/download?openExternalBrowser=1&id=k34ma9opy1t5n67";

export * from "./codes";
export * from "./context";
